import "../css/app.css";
import "./bootstrap";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "../css/custom-dashboard.css";

import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@/Components/theme-provider";
import { ToastProvider } from "@/Components/ui/ToastContext";
import axios from "axios";
import React from "react";

const appName = import.meta.env.APP_NAME || "FAZ-Drill";

// Initialize Sanctum and CSRF protection
const initializeApp = async () => {
    try {
        axios.defaults.withCredentials = true;
        axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
        axios.defaults.headers.common["Accept"] = "application/json";
        axios.defaults.xsrfCookieName = "XSRF-TOKEN";
        axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

        await axios.get("/sanctum/csrf-cookie");
        console.log("✅ Sanctum initialized successfully");
    } catch (error) {
        console.error("❌ Failed to initialize Sanctum:", error);
    }
};

initializeApp().then(() => {
    createInertiaApp({
        title: (title) => `${title} - ${appName}`,
        resolve: (name) =>
            resolvePageComponent(
                `./Pages/${name}.jsx`,
                import.meta.glob("./Pages/**/*.jsx")
            ),
        setup({ el, App, props }) {
            const root = createRoot(el);

            console.log(
                "🔍 App props user:",
                props.initialPage.props.auth.user,
            );

            root.render(
                <React.StrictMode>
                <ThemeProvider user={props.initialPage.props.auth.user}>
                    <ToastProvider>
                        {/*{console.log('Current Mode:', import.meta.env.MODE)}*/}
                        <App {...props} />
                    </ToastProvider>
                </ThemeProvider>
                </React.StrictMode>
            );
        },
        progress: {
            color: "#4B5563",
        },
    });
});
